import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useTriggerPasswordChange = () => {
  const { call } = useApiPrivateRequest();
  const triggerPasswordChange = async (userId: string) => {
    await call(`/admin/users/${userId}/password`, "DELETE");
  };
  return { triggerPasswordChange };
};
